
import { useEffect } from "react";
import { AuthCheck } from "@/components/auth/AuthCheck";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { ProgramsList } from "@/components/programs/list/ProgramsList";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";

export default function Programs() {
  const storedAvatar = localStorage.getItem('userAvatar') || "/placeholder.svg";
  const storedName = localStorage.getItem('userName') || "Coach";
  const { refreshPermissions } = usePermissionCheck();

  useEffect(() => {
    // Refresh permissions when the page loads
    refreshPermissions();
  }, [refreshPermissions]);

  return (
    <AuthCheck>
      <DashboardLayout avatar={storedAvatar} name={storedName}>
        <main className="p-6 space-y-6 overflow-y-auto">
          <ProgramsList />
        </main>
      </DashboardLayout>
    </AuthCheck>
  );
}
